/* global femcare */

femcare.modal = {

    init: function () {
        this.initGenericModal();
    },

    initGenericModal: function () {
        femcare.shared.util.$modal.genericModal();
    }
};